export enum VerificationRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  SKIPPED = 'SKIPPED',
  ALL = 'ALL',
  NONE = 'NONE'
}

export enum VERIFICATION_REQUEST_TAB {
  PROFILE = 'PROFILE',
  BUSINESS = 'BUSINESS'
}
